import { render, staticRenderFns } from "./BodyOnduleur.vue?vue&type=template&id=5f0003c4&scoped=true"
import script from "./BodyOnduleur.vue?vue&type=script&lang=js"
export * from "./BodyOnduleur.vue?vue&type=script&lang=js"
import style0 from "./BodyOnduleur.vue?vue&type=style&index=0&id=5f0003c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0003c4",
  null
  
)

export default component.exports